import cx from 'clsx';
import { Text } from '@paylink/constants';

import {
	type ISubscriptionDetails,
	SubscriptionFrequency,
	SubscriptionFrequencyLabels,
} from '@shared/types';
import { formatAmount } from '@shared/utils';
import { Show } from '@shared/components/common';

import styles from './AmountSummary.module.scss';

interface IAmountSummaryProps {
	amount: number;
	subscriptionDetails?: ISubscriptionDetails;
	isMobile?: boolean;
}

const AmountSummary = ({
	amount,
	subscriptionDetails,
	isMobile = false,
}: IAmountSummaryProps) => {
	if (!subscriptionDetails) {
		return (
			<Show
				when={isMobile}
				fallback={
					<div className="d-flex items-center gap2 bg-white border1 border-grey2 border-radius3 p4 card-shadow1 width100">
						<span className="flex1 bolder h3 dark1 lh2">{Text.TOTAL}</span>
						<span className="h6 lighter dark2 lh16">:</span>
						<span className="flex1 bolder h3 dark3 right-align lh2">
							{formatAmount(amount)}
						</span>
					</div>
				}
			>
				<div>
					<p className={cx('medium body grey2 my0 lh6', styles.overline)}>
						{Text.TOTAL_AMOUNT}
					</p>
					<div className="bolder h1 dark3 mb0 mt1 lhp125 ls0">
						{formatAmount(amount)}
					</div>
				</div>
			</Show>
		);
	}

	const frequencyLabel =
		SubscriptionFrequencyLabels[
			subscriptionDetails.frequency as SubscriptionFrequency
		];
	const recurringAmount = `${formatAmount(subscriptionDetails.maxAmount)}${
		typeof frequencyLabel === 'string' ? ` ${frequencyLabel.toLowerCase()}` : ''
	}`;

	return (
		<div className="bg-white border1 border-grey2 border-radius3 card-shadow1 overflow-hidden width100">
			<div
				className={cx(
					'd-flex items-center gap2 p4 border-bottom1',
					styles.summaryRow,
				)}
			>
				<span className={cx('flex1 medium body grey2', styles.overline)}>
					{Text.PAY_NOW}
				</span>
				<span className="h6 lighter dark2 lh16">:</span>
				<span className="flex1 bolder h3 dark3 right-align lh2">
					{formatAmount(amount)}
				</span>
			</div>
			<div className="d-flex items-center gap2 p4">
				<span className={cx('flex1 medium body grey2', styles.overline)}>
					{Text.RECURRING_AMOUNT}
				</span>
				<span className="flex1 bolder h4 dark3 right-align lh2">
					{recurringAmount}
				</span>
			</div>
		</div>
	);
};

export default AmountSummary;
